// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import About from "./pages/About";
import Contact from "./pages/Contact";
import MyOrders from "./pages/MyOrders";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import "./styles.css";

function Layout({ children, noFooter }) {
  return (
    <>
      <Navbar />
      <div className="page-wrapper">{children}</div>
      {!noFooter && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <CartProvider>
            <Toaster position="top-right" toastOptions={{ style: { fontFamily: "inherit" } }} />
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/tienda" element={<Layout><Shop /></Layout>} />
              <Route path="/producto/:id" element={<Layout><ProductDetail /></Layout>} />
              <Route path="/carrito" element={<Layout><Cart /></Layout>} />
              <Route path="/checkout" element={<Layout noFooter><Checkout /></Layout>} />
              <Route path="/confirmacion/:id" element={<Layout><OrderConfirmation /></Layout>} />
              <Route path="/nosotros" element={<Layout><About /></Layout>} />
              <Route path="/contacto" element={<Layout><Contact /></Layout>} />
              <Route path="/mis-pedidos" element={<Layout><MyOrders /></Layout>} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/*" element={<Admin />} />
              <Route path="*" element={
                <Layout>
                  <div className="empty-state page-pad" style={{ minHeight:"60vh" }}>
                    <h2>Página no encontrada</h2>
                    <a href="/" className="btn-primary">Volver al inicio</a>
                  </div>
                </Layout>
              } />
            </Routes>
          </CartProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
